// ./src/components/features/FormFields/FormFieldTypeIcon/FormFieldTypeIcon.tsx
import React, { useMemo } from "react";
import { useFormFieldTypesContext } from "@/contexts";
import { AppIcon } from "@/components/generic";

export interface FormFieldTypeIconProps {
  /** Field type ID (numeric) */
  fieldType: number | null | undefined;

  /** Icon size */
  size?: number;

  /** Color (Mantine color or CSS color) */
  color?: string;

  /** Additional styles */
  style?: React.CSSProperties;
}

export const FormFieldTypeIcon: React.FC<FormFieldTypeIconProps> = ({
  fieldType,
  size = 18,
  color,
  style,
}) => {
  const { formFieldTypes } = useFormFieldTypesContext();

  const iconName = useMemo(() => {
    if (fieldType == null) return "HelpCircle";
    const type = formFieldTypes.find((ft) => ft.id === fieldType.toString());
    return type?.iconName || "HelpCircle";
  }, [fieldType, formFieldTypes]);

  return (
    <AppIcon iconName={iconName} size={size} color={color} style={style} />
  );
};
